<script>
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils';
    import {onMount} from 'svelte';
    import MobileFooter from '../../reusableitems/mobileFooter.svelte';

    let main;
    let ImageDiv;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation( main, main, [{backgroundColor: '#F4EEEC', duration: 1},
            {backgroundColor: '#FFFFFF', duration: 1}], 3);
        initializeGsapAnimation( main, ImageDiv, [{y: '-28vw', x: '20.598vw', scale: 1.5, duration: 1},
            {y: 0, x: 0, scale: 1, duration: 1}], 3);
}
</script>

<div class="bg" bind:this={main}>
    <div class="img3">
        <img id="img3" src="images/performersMobile/4.svg" alt="" />
    </div>
    <div class="performers4">
        <div class="bg4" >
            <img id="bg4" src="images/performersMobile/bg4.svg" alt="" />
        </div>
        <div class="bg45"  style="" bind:this={ImageDiv}>
            <img id="bg45" src="images/performersMobile/bg45.svg" alt="" />
            <!-- <div class="btn"><Mobilebtn text2="(Choreography Seat)" /></div> -->
        </div>
        <div class="sub">Performers & Opus</div>
        <div class="h1">CHOREOGRAPHY</div>
        <div class="para1">
            <p>
                Choreography is as old as the human subspecies itself. It's part
                of our genetic composition and something that enthralls us all
                alike.
            </p>
            <p>
                Our<span style="color:#1C7BFF;font-weight:600;"><u>motion recording app</u></span> turns a simple smartphone into a
                performance capture studio without any specialized equipment.
                Become part of the future of democratized entertainment in the
                making.
            </p>
        </div>
        <div class="btn">
            <Mobilebtn  state='Performer'/>
        </div>
        <div class="footer">
            <MobileFooter/>
        </div>
    </div>
</div>

<style>
     .img3 {
        position: relative;
        height: 70.093vw;
        width: 51.402vw;
        top: max(2.916vw, 1.35vh);
    }
    #img3 {
        height: 100%;
        width: 100%;
    }
    .btn {
        position: absolute;
        right: 6.308vw;
        bottom: 30.607vw;
        z-index: 5;
    }
    .bg {
        position: relative;
        overflow: hidden;
        height: max(216.355vw, 100.16vh);
        font-family: "Orbitron";
        background-color: #FFFFFF;
    }
    .performers4 {
        height: max(216.355vw, 100.16vh);
    }

    #bg4 {
        position: absolute;
    }

    .bg4,
    .bg45 {
        position: absolute;
        height: 108.178vw;
        width: 147.43vw;
        left: -23.598vw;
        top: max(106.813vw, 49.45vh);

        /*  height: 120.607vw;
        width: 90vw;
        left: 0vw;
        top: 95.561vw;*/
    }
    .bg45 {
        height: 106.402vw;
        width: 109.112vw;
        left: -26vw;
        top: max(76.439vw, 35.38vh);
        z-index: 1;
    }
    #bg4,
    #bg45 {
        height: 100%;
        width: 100%;
    }
    .sub {
        position: absolute;
        left: 7.29vw;
        top: max(39.019vw, 18.064vh);
        font-size: 2.336vw;
        font-weight: 400;
        line-height: 2.336vw;
        text-align: left;
    }
    .h1 {
        position: absolute;
        font-size: 7.009vw;
        font-weight: 900;
        line-height: 9.009vw;
        letter-spacing: 0.8vw;
        text-align: left;
        left: 6.308vw;
        top: max(42.991vw, 19.903vh);
        background-color: #f4eeec;
        z-index: 2;
    }
    .para1 {
        font-family: "Orbitron";
        position: absolute;
        font-size: 2.804vw;
        font-weight: 400;
        line-height: 4.972vw;
        letter-spacing: 0.06em;
        text-align: left;
        display: flex;
        flex-direction: column;
        width: 61.879vw;
        left: 6.748vw;
        top: max(55.869vw, 25.865vh);
    }

    .footer {
      position: absolute;
      bottom: 0vw;
      width: 100%;
    }
</style>
